import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { checkoutRedirectUrl, redirectToPaymentProvider } from '@/redux/thunks/checkout/index';
import { valueof } from '@/types';
import { tryCatch } from '@/redux/thunks/shared/try-catch';
import { LocalStorageService } from '@/services/LocalStorage.service';
import { isObjectEmpty } from '@/utils/comparisonUtils';
import { PAYMENT_PLATFORMS } from '@/constants/checkout';

const manageCartId = (cartId: string) => {
  LocalStorageService.set(cartId, 'processing payment validation');
};

export const PENDING_REQUEST = 'pending-request';

export const validatePayment = createAppAsyncThunk(
  'checkout/validatePayment',
  async (
    optionalData:
      {
        details?: unknown, transactionId?: string, redirectResult?: string, provider?: valueof<typeof PAYMENT_PLATFORMS>
      } | null = null,
    { rejectWithValue, getState, dispatch, extra: { checkoutService } }
  ) => {
    const cart = getState().cart.content;

    if (!isObjectEmpty(LocalStorageService.get(cart.id)) && LocalStorageService.get(cart.id) !== '') {
      return rejectWithValue({ cause: PENDING_REQUEST });
    }

    manageCartId(cart.id);

    const paymentData = {
      ...(optionalData || {}),
      dispatch
    };

    const { data, error } = await tryCatch(
      checkoutService.validatePayment(cart, paymentData)
    );

    if (error) {
      await redirectToPaymentProvider('/checkout/pay');
      return rejectWithValue({
        message: 'errors.genericErrorMessage.main'
      });
    }

    if (!data) {
      await redirectToPaymentProvider('/checkout/pay');
      return rejectWithValue({ message: 'errors.genericErrorMessage.main' });
    }

    if (data.redirectUrl) {
      await redirectToPaymentProvider(data.redirectUrl);
    } else {
      await checkoutRedirectUrl('/report');
    }

    return data;
  }
);
